import { Box, Checkbox, FormControl } from '@chakra-ui/react'

export const GapDefendTab = ({
  defaultChecked,
  onChange,
}: {
  defaultChecked: boolean
  onChange: (value: boolean) => void
}) => {
  return (
    <Box>
      <FormControl>
        <Checkbox defaultChecked={defaultChecked} onChange={(e) => onChange(e.target.checked)}>
          Sjednat GAP Defend
        </Checkbox>
      </FormControl>
    </Box>
  )
}
